import { CustomInput, Label, Alert, Badge, FormText, Button } from 'reactstrap'
import AccountLinkSellerDetailView from 'domains/account-link/molecules/seller-detail-view'
import AccountLinkCustomerDetailView from 'domains/account-link/molecules/customer-detail-view'
import PropTypes from 'prop-types'

const propTypes = {
  accounts      : PropTypes.array,
  setFieldValue : PropTypes.func,
  handleChange  : PropTypes.func,
  selectedValue : PropTypes.string,
  errorMessage  : PropTypes.string
}

const defaultProps = {
  accounts: []
}

const AccountLinkAccountOptions = ({
  accounts,
  setFieldValue,
  handleChange,
  selectedValue,
  errorMessage
}) => {
  const existingAccounts = accounts.filter((account) => account.id)
  const isAccountsEmpty  = existingAccounts.length === 0
  return (
    <>
      <Label
        className='text-gray-light text-capitalize'
      >
        <strong>{ 'Selected Account' }</strong>
      </Label>
      <Badge
        color='warning'
        className='ml-1'
      >
        <i className='fas fa-asterisk' />
      </Badge>
      { errorMessage && <FormText className='mb-3'>* { errorMessage }</FormText> }
      {
        existingAccounts.map((account, index) => {
          const isSeller = account.type === 'seller'
          if (account.id) {
            return (
              <div key={ `account-radio-${account.id}-${index}` }>
                <div className='d-flex justify-content-between mb-3 align-items-center'>
                  <CustomInput
                    id={ `account-radio-${account.id}-${index}` }
                    type='radio'
                    checked={ selectedValue === account.type }
                    onChange={ (e) => handleChange('selected_account', e.target.value, setFieldValue ) }
                    label={ account.email }
                    value={ account.type }
                    className="mb-3 font-weight-bold"
                  />
                  <Button
                    color='danger'
                    size='sm'
                    onClick={ () => handleChange(account.type, {}, setFieldValue) }
                  >
                    { 'Remove' }
                  </Button>
                </div>
                {
                  isSeller ?
                    <AccountLinkSellerDetailView selectedSeller={ account } />
                    : <AccountLinkCustomerDetailView selectedCustomer={ account } />
                }
              </div>
            )
          }
        })
      }
      <Alert
        className={ isAccountsEmpty ? 'd-block' : 'd-none' }
        color='info'
      >
        <i className='fas fa-info-circle mr-3' />
        <span>
          { 'Please search a Customer or Seller first' }
        </span>
      </Alert>
    </>
  )
}

AccountLinkAccountOptions.propTypes    = propTypes
AccountLinkAccountOptions.defaultProps = defaultProps

export default AccountLinkAccountOptions